// How the market's open and close are shown in the notification centre.

import type { NotificationPresenter } from "@/notifications/client";
import { IconTrending } from "@/platform/ui";
import { MARKET_NOTIFICATIONS } from "@/finance/model/constants.js";

export const marketNotifications: NotificationPresenter = {
  source: MARKET_NOTIFICATIONS,
  icon: (_, size) => <IconTrending size={size} />,
};
